module.exports = __webpack_public_path__ + "static/media/chatsupport.4083eab5.png";